/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AppContainer_auth = {
    readonly " $fragmentRefs": FragmentRefs<"SignInContainer_auth" | "SignUpContainer_auth" | "AccountCompletionContainer_auth">;
    readonly " $refType": "AppContainer_auth";
};
export type AppContainer_auth$data = AppContainer_auth;
export type AppContainer_auth$key = {
    readonly " $data"?: AppContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"AppContainer_auth">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppContainer_auth",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SignInContainer_auth"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SignUpContainer_auth"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountCompletionContainer_auth"
        }
    ],
    "type": "Auth",
    "abstractKey": null
} as any);
(node as any).hash = 'db7563541ddf404a6159f5a0bec9681c';
export default node;
